import { createFileRoute } from "@tanstack/react-router";

import PendingBookingsPage from "@/admin/pending-bookings/page";

export const Route = createFileRoute("/app/$storeId/pending-bookings")({
    component: RouteComponent,
});

function RouteComponent() {
    return <PendingBookingsPage />;
}
